import { createContext, ReactNode, useState } from 'react';

export const UserContext = createContext<{
  user: any;
  setUser: React.Dispatch<React.SetStateAction<any | null>>;
}>({
  user: null,
  setUser: () => {},
});

interface IUserContextProviderProps {
  children: ReactNode;
}

export const UserContextProvider = ({
  children,
}: IUserContextProviderProps) => {
  const [user, setUser] = useState<any | null>(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
